module.exports = __webpack_public_path__ + "static/media/ml.02a95bc1.svg";